const productImages = import.meta.glob('/src/assets/Products/*', { eager: true, import: 'default' });

export function getProductImage(path) {
  if (!path) return '';
  if (productImages[path]) {
    return productImages[path];
  }
  return path;
}
